import { render, staticRenderFns } from "./SnackNotificacion.vue?vue&type=template&id=f4da81fa&"
import script from "./SnackNotificacion.vue?vue&type=script&lang=ts&"
export * from "./SnackNotificacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports